import i18next from 'i18next';

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export function parseNumberInput(rawValue: string): number | undefined {
  if (rawValue.trim() === '') {
    return undefined;
  }

  const parsed: number = Number(rawValue);

  return Number.isNaN(parsed) ? undefined : parsed;
}

export function formatMinutes(value: number): string {
  return new Intl.NumberFormat(i18next.language, { maximumFractionDigits: 0 }).format(value);
}

export function formatPercentage(value: number): string {
  return new Intl.NumberFormat(i18next.language, { maximumFractionDigits: 1 }).format(value);
}
